var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-1 pb-2 mx-3 flex justify-between items-center flex-wrap"},[_c('div',{class:[
      'text-body-extra-small flex items-center space-x-1',
      {
        'text-dark-text-200': _setup.darkMode === false,
        'text-light-text-200': _setup.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
      },
    ]},[_c('span',[_vm._v("\n      "+_vm._s(_setup.n__('%{totalVotesCount} vote', '%{totalVotesCount} votes', _setup.totalVotesCount, {
          totalVotesCount: _setup.totalVotesCount,
        }))+"\n    ")]),_vm._v(" "),(_setup.xResultsToggle)?[_c('span',{class:[
          'font-semibold',
          {
            'text-dark-text-300': _setup.darkMode === false,
            'text-light-text-300': _setup.darkMode === true,
            'text-dark-text-300 dark:text-light-text-300': _setup.darkMode === 'auto',
          },
        ]},[_vm._v("•")]),_vm._v(" "),_c(_setup.OzPlainButton,{class:[
          'font-semibold rounded-xl hover-hover:focus-visible:ring-2',
          {
            'text-dark-text-200': _setup.darkMode === false,
            'text-light-text-200': _setup.darkMode === true,
            'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
          },
        ],attrs:{"tabindex":0,"dark-mode":_setup.darkMode,"text":_setup.isShowingPollResults ? _setup.__('Hide Results') : _setup.__('Show Results'),"color-scheme":_setup.OzPlainButtonColorScheme.Secondary,"size-preset":_setup.OzPlainButtonSizePreset.Bare},on:{"click":_setup.togglePollResults}})]:(_setup.isPollClosed)?[_c('span',{class:{
          'text-dark-text-300': _setup.darkMode === false,
          'text-light-text-300': _setup.darkMode === true,
          'text-dark-text-300 dark:text-light-text-300': _setup.darkMode === 'auto',
        }},[_vm._v("•")]),_vm._v(" "),_c('span',{class:{
          'text-dark-text-200': _setup.darkMode === false,
          'text-light-text-200': _setup.darkMode === true,
          'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
        }},[_vm._v("\n        "+_vm._s(_setup.__('Poll closed'))+"\n      ")])]:_vm._e()],2),_vm._v(" "),(_setup.xVoteButton)?_c(_setup.OzContainedButton,{staticClass:"no-drag",attrs:{"size-preset":_setup.OzContainedButtonSizePreset.H24px,"text":_setup.__('Vote'),"label":_setup.__('Vote'),"disabled":_setup.isVoteButtonDisabled},on:{"click":function($event){return _setup.emit('vote')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }